// features/doctor/doctorSlice.js
// Mirrors the shape of your existing userSlice (features/user/userSlice.js)
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  doctorInfo: null,
  token: null,
};

const doctorSlice = createSlice({
  name: 'doctor',
  initialState,
  reducers: {
    setDoctor: (state, action) => {
      state.doctorInfo = action.payload.doctorInfo;
      state.token = action.payload.token;
    },
    clearDoctor: (state) => {
      state.doctorInfo = null;
      state.token = null;
    },
  },
});

export const { setDoctor, clearDoctor } = doctorSlice.actions;
export default doctorSlice.reducer;

// Add this reducer to your store, alongside the existing user reducer:
//   import doctorReducer from './features/doctor/doctorSlice';
//   export const store = configureStore({
//     reducer: { user: userReducer, doctor: doctorReducer },
//   });